module.exports = __webpack_public_path__ + "static/logo-0e19f03d49d1884a5f77bcaae2413784.jpg";